import ConfirmModal from "@app/components/confirm-modal";
import { addToast } from "@app/components/toast/toast.service";
import { ACCESS_TOKEN_KEY, PathnameUrl } from "@app/constants";
import AccountService from "@app/services/http/account.service";
import { openPortalDialog } from "@app/services/modal.service";
import SocketService from "@app/services/socket.service";
import useObservable from "@core/hooks/use-observable.hook";
import StorageService from "@core/services/storage";
import { Environment } from "@environments/environment";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Subscription } from "rxjs";

const EkycComponent = () => {
  const navigate = useNavigate();
  const { subscribeUntilDestroy } = useObservable();

  // Lấy thông tin User hiện tại từ hệ thống
  useEffect(() => {
    subscribeUntilDestroy(AccountService.getMyInfo(), (res) => {
      if (res) {
        if (res.isVerify === 1) {
          const obs = openPortalDialog(ConfirmModal, {
            message:
              "Bạn đã xác minh danh tính. Không cần thực hiện lại thao tác này!",
          });

          obs.afterClosed().subscribe(() => {
            navigate("/");
          });
        } else if (res.numberEkycFail >= 6) {
          const obs = openPortalDialog(ConfirmModal, {
            message:
              "Bạn đã xác minh sai quá số lần quy định. Vui lòng thử lại vào ngày hôm sau!",
          });

          obs.afterClosed().subscribe(() => {
            navigate("/");
          });
        }
      }
    });
  }, []);

  //socket nhận thông báo lỗi
  const subscription = new Subscription();

  useEffect(() => {
    const sub = SocketService.onErrorResponse().subscribe((data) => {
      addToast({ text: data.toString(), status: "inValid" });

      if (
        data.includes("Khuôn mặt không hợp lệ") ||
        data.includes("giấy tờ không hợp lệ") ||
        data.includes(
          "Thông tin của bạn đã tồn tại, hệ thống tạm khóa tài khoản của bạn để đảm bảo an toàn dữ liệu, vui lòng liên hệ fanpage của chúng tôi để được hỗ trợ."
        )
      ) { 
        openPortalDialog(ConfirmModal, { message: data });

        // obs.afterClosed().subscribe(() => {
        // });

        navigate(PathnameUrl.IDENTITY_VERIFICATION);
      }
    });

    subscription.add(sub);
  }, [subscription]);

  useEffect(() => () => subscription.unsubscribe(), [subscription]);

  // Cờ chặn việc chạy lặp lại nhiều lần
  const isHandledRef = useRef(false);

  useEffect(() => {
    const token = StorageService.get(ACCESS_TOKEN_KEY);

    const dataConfig = {
      BACKEND_URL: `${Environment.BASE_API}/accounts/ekyc`,
      // BACKEND_URL: "https://api.idg.vnpt.vn",
      TOKEN_KEY: `Bearer ${token}`,
      // TOKEN_ID: "",
      // ACCESS_TOKEN: "",
      ENABLE_GGCAPCHAR: true,
      PARRENT_ID: "ekyc_sdk_intergrated",
      FLOW_TYPE: "DOCUMENT", // DOCUMENT, FACE
      SHOW_RESULT: true,
      SHOW_HELP: true,
      SHOW_TRADEMARK: false,
      CHECK_LIVENESS_CARD: true,
      CHECK_LIVENESS_FACE: true,
      CHECK_MASKED_FACE: true,
      COMPARE_FACE: true,
      LANGUAGE: "vi",
      TYPE_DOCUMENT: 99,
      LIST_TYPE_DOCUMENT: [-1, 5, 6],
      //       	Tùy chọn loại giấy tờ để ekyc.
      // -1: Chứng minh thư
      // 5: Hộ chiếu
      // 6: Bằng Lái Xe
      // 7: Chứng minh thư quân đội
      // 99: Hiển thị danh sách chọn loại giấy tờ.
      USE_WEBCAM: true,
      USE_UPLOAD: false,
      ADVANCE_LIVENESS_FACE: true,
      LIST_CHOOSE_STYLE: {
        background: "#fff",
        text_color: "black",
        border_item: "",
        item_active_color: "#18D696",
        background_icon: "#18D696",
        id_icon: "https://ekyc-web.icenter.ai/images/si/id_card.svg",
        passport_icon: "https://ekyc-web.icenter.ai/images/si/passport.svg",
        drivecard_icon: "https://ekyc-web.icenter.ai/images/si/drivecard.svg",
        army_id_icon: "https://ekyc-web.icenter.ai/images/si/other_doc.svg",
        id_chip_icon: "https://ekyc-web.icenter.ai/images/si/id_chip.svg",
        start_button_background: "#18D696",
        start_button_color: "#111127",
      },
      CAPTURE_IMAGE_STYLE: {
        popup1_box_shadow:
          "0px 0px 2px rgba(0, 0, 0, 0.06), 0px 3px 8px rgba(0, 0, 0, 0.1)",
        popup1_title_color: "#C8242D",
        description1_color: "#fff",
        capture_btn_background: "#18D696",
        capture_btn_color: "#111127",
        capture_btn_icon:
          "https://ekyc-web.icenter.ai/images/hdbank/capture.svg",
        tutorial_btn_icon: "https://ekyc-web.icenter.ai/images/hdbank/help.gif",
        recapture_btn_background:
          "linear-gradient(180deg, #FDFDFD 0%, #DEDEDE 100%)",
        recapture_btn_color: "#111127",
        recapture_btn_border: "2px solid #FEDC00",
        recapture_btn_icon:
          "https://ekyc-web.icenter.ai/images/hdbank/capture.svg",
        nextstep_btn_background: "#18D696",
        nextstep_btn_color: "#111127",
        nextstep_btn_icon:
          "https://ekyc-web.icenter.ai/images/hdbank/next_icon.svg",
        popup2_box_shadow:
          "0px 0px 2px rgba(0, 0, 0, 0.06), 0px 3px 8px rgba(0, 0, 0, 0.1)",
        popup2_title_header_color: "#C8242D",
        popup2_icon_header:
          "https://ekyc-web.icenter.ai/images/hdbank/main_icon.svg",
        popup2_icon_warning1: "",
        popup2_icon_warning2: "",
        popup2_icon_warning3: "",
      },
      RESULT_DEFAULT_STYLE: {
        redemo_btn_background: "#18D696",
        redemo_btn_icon:
          "https://ekyc-web.icenter.ai/images/hdbank/refresh.svg",
        redemo_btn_color: "#111127",
      },
      MOBILE_STYLE: {
        mobile_capture_btn:
          "https://ekyc-web.icenter.ai/images/capure_mobile.png",
        mobile_capture_desc_color: "#18D696",
        mobile_tutorial_color: "#C8242D",
        mobile_recapture_btn_background:
          "linear-gradient(180deg, #FDFDFD 0%, #DEDEDE 100%)",
        mobile_recapture_btn_border: "1px solid #18D696",
        mobile_recapture_btn_icon:
          "https://ekyc-web.icenter.ai/images/hdbank/capture.svg",
        mobile_recapture_btn_color: "#111127",
        mobile_nextstep_btn_background: "#18D696",
        mobile_nextstep_btn_color: "#111127",
        mobile_nextstep_btn_icon:
          "https://ekyc-web.icenter.ai/images/next_icon_b.png",
        mobile_popup2_icon_header:
          "https://ekyc-web.icenter.ai/images/hdbank/face_icon_popup.svg",
      },
    };

    if ((window as any).SDK) {
      (window as any).SDK.launch(dataConfig);
    }

    const id = setInterval(() => {
      // 🛡️ BẢO VỆ 1: Nếu đã xử lý xong rồi thì dọn dẹp interval ngay lập tức và dừng lại
      if (isHandledRef.current) {
        clearInterval(id);

        return;
      }

      const targetNode = document.getElementById("ekyc_sdk_intergrated");

      if (targetNode) {
        const btn = document.querySelector(
          ".vnpt-inline-block.vnpt-cursor-pointer.vnpt-rounded-primary.vnpt-bg-primary.vnpt-px-20.vnpt-py-4.vnpt-font-open.vnpt-text-base.vnpt-font-semibold.vnpt-text-gray-900"
        );

        const element = document.querySelectorAll(
          "[class='vnpt-font-open vnpt-text-sm vnpt-font-semibold vnpt-text-gray-900 sm:vnpt-text-base']"
        );

        if (
          btn &&
          element.length > 1 &&
          element[0] &&
          element[0].textContent === "Hợp lệ" &&
          element[9] &&
          element[9].textContent?.toString()?.includes("Khuôn mặt khớp")
        ) {
          // 🛡️ BẢO VỆ 2: Đánh dấu ngay lập tức là ĐÃ XỬ LÝ xong
          isHandledRef.current = true;
          clearInterval(id);

          const obs = openPortalDialog(ConfirmModal, {
            message:
              "eKYC thành công. Bước tiếp theo, bạn cần ký chữ ký điện tử để hoàn tất.",
            countdownSeconds: 9,
          });

          obs.afterClosed().subscribe((res) => {
            if (res?.isAccept) {
              navigate(PathnameUrl.IDENTITY_VERIFICATION);
            } else {
              // navigate("/");
            }
          });
        }
      }
    }, 3000); // Hạ bớt xuống 1.5s để mượt hơn

    // 🛡️ BẢO VỆ 3: Cleanup function chuẩn của React Effect
    // Khi component unmount hoặc re-render, dừng ngay interval đang chạy ngầm
    return () => {
      clearInterval(id);
    };
  }, []);

  return (
    <div>
      <div id="ekyc_sdk_intergrated"></div>
    </div>
  );
};

export default EkycComponent;
